import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Spinner from "views/lib/components/Spinner";
import BikeSingleInfo from "views/pages/bikes/bike-single-info";
import BikeSingleHistory from "views/pages/bikes/bike-single-history";
import ModalUpdate from "views/pages/bikes/modal-update";
import BikePath from "views/pages/bikes/bike-path";
import { closeCustomModal, openCustomModal } from "views/lib/components/modals";
import { getSingleBike, updateBike, updateBikeStatus } from "actions/bike/actions";

class BikeSingle extends React.Component {
    constructor(props) {
        super(props);

        this.handleEditModal = this.handleEditModal.bind(this);
        this.updateBikeStatus = this.updateBikeStatus.bind(this);

        const { bikeId } = this.props.match.params;
        this.props.getSingleBike(bikeId);
    }

    handleEditModal = () => {
        const { single } = this.props;
        const modalObj = {
            modalSettings: {
                size: "sm"
            },
            header: "Update Bike",
            children: (
                <ModalUpdate
                    bike={single}
                    onCancel={() => this.props.closeCustomModal(modalObj)}
                    onSubmit={(single) => {
                        this.props.updateBike(single);
                        this.props.closeCustomModal(modalObj);
                    }}
                />
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    updateBikeStatus = (status) => {
        const { single } = this.props;
        this.props.updateBikeStatus(single.id, status);
    };

    render() {
        const { bikeId } = this.props.match.params;
        const {
            single,
            loading,
        } = this.props;

        return (
            <div className="m-2 position-relative">
                {!loading || <Spinner />}

                <Card className="rounded-0">
                    <Card.Header>
                        <div className="d-flex justify-content-between">
                            <div className="d-inline-flex align-items-center">
                                Bike
                            </div>

                            <button
                                className="btn btn-outline-danger"
                                onClick={this.handleEditModal}
                            >
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </button>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <BikeSingleInfo
                            bikeInfo={single}
                            updateBikeStatus={this.updateBikeStatus}
                        />
                    </Card.Body>
                </Card>

                <Tabs defaultActiveKey="history" id="bike-history-tabs">
                    <Tab eventKey="history" title="History (last 10)">
                        <BikeSingleHistory bikeId={bikeId} />
                    </Tab>
                    <Tab eventKey="path" title="Trip last">
                        <BikePath bikeId={bikeId} />
                    </Tab>
                </Tabs>
                {/*
                <Card className="rounded-0">
                    <Card.Header>
                        <div className="d-flex justify-content-between">
                            <div className="d-inline-flex align-items-center">
                                History(last 10)
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <BikeSingleHistory bikeId={bikeId} />
                    </Card.Body>
                </Card>
                */}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.bike.loading,
    single: state.bike.single,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getSingleBike: bindActionCreators(getSingleBike, dispatch),
    updateBike: bindActionCreators(updateBike, dispatch),
    updateBikeStatus: bindActionCreators(updateBikeStatus, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(BikeSingle);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/bike-single.js